// extracted by mini-css-extract-plugin
export default {"container":"AddNewPaymentMethod_container__UrHP+","contrast":"AddNewPaymentMethod_contrast__D6rA0","visaMaser":"AddNewPaymentMethod_visaMaser__Xr7dM"};